export default __webpack_public_path__ + "static/media/gauge-white.ef5fb88c.svg";